import { z } from 'zod';
import { date } from '@/schemas/API/common/atomic/date';

export const employeeCardSchema = z.object({
  type: z.string(),
  issAt: date,
  expAt: date.nullable(),
  deposit: z.string().nullable(),
});
